import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button'
import { InputText } from 'primereact/inputtext'
import { Tag } from 'primereact/tag'
import { Chip } from 'primereact/chip'
import { mockProjects, mockClients } from '../../../mocks'
import { Project } from '../../../types/entities'
import { projectStatusLabel, projectStatusSeverity } from '../utils/projectHelpers'

const ProjectsListPage: React.FC = () => {
  const navigate = useNavigate()
  const [search, setSearch] = useState('')

  const filtered = mockProjects.filter(
    (p) =>
      p.name.toLowerCase().includes(search.toLowerCase()) ||
      p.hosting.toLowerCase().includes(search.toLowerCase())
  )

  const clientTemplate = (project: Project) => {
    const client = mockClients.find((c) => c.id === project.clientId)
    return client?.name ?? '–'
  }

  const statusTemplate = (project: Project) => (
    <Tag value={projectStatusLabel(project.status)} severity={projectStatusSeverity(project.status)} />
  )

  const stackTemplate = (project: Project) => (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.35rem' }}>
      {project.techStack.slice(0, 3).map((t) => (
        <Chip key={t} label={t} style={{ fontSize: '0.75rem', padding: '0.15rem 0.5rem' }} />
      ))}
      {project.techStack.length > 3 && (
        <Chip label={`+${project.techStack.length - 3}`} style={{ fontSize: '0.75rem', padding: '0.15rem 0.5rem' }} />
      )}
    </div>
  )

  const actionsTemplate = (project: Project) => (
    <Button
      icon='pi pi-eye'
      text
      severity='secondary'
      tooltip='Ver detalhes'
      onClick={() => navigate(`/dashboard/aplicativos/${project.id}`)}
    />
  )

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
        <div>
          <h2 style={{ margin: 0 }}>Aplicativos</h2>
          <p style={{ margin: '0.25rem 0 0', color: 'var(--text-color-secondary)' }}>
            {mockProjects.length} aplicativos cadastrados
          </p>
        </div>
        <span className='p-input-icon-left'>
          <i className='pi pi-search' />
          <InputText
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder='Buscar aplicativo...'
          />
        </span>
      </div>

      <DataTable
        value={filtered}
        paginator
        rows={10}
        emptyMessage='Nenhum aplicativo encontrado.'
        rowHover
        onRowClick={(e) => navigate(`/dashboard/aplicativos/${(e.data as Project).id}`)}
        style={{ cursor: 'pointer' }}
      >
        <Column field='name' header='Nome' sortable />
        <Column header='Cliente' body={clientTemplate} sortable sortField='clientId' />
        <Column field='hosting' header='Hospedagem' sortable />
        <Column header='Stack' body={stackTemplate} />
        <Column header='Status' body={statusTemplate} sortable sortField='status' />
        <Column header='' body={actionsTemplate} style={{ width: '60px', textAlign: 'center' }} />
      </DataTable>
    </div>
  )
}

export default ProjectsListPage
